export enum CustomerSurveyOrderBy {
  CREATED = "Created",
  TITLE = "Title"
}

export enum LIST_COMPANY_DATA_ORDER_BY {
  VENDOR_COMPANY_NAME = "VendorCompanyName",
  SURVEY_TITLE = "SurveyTitle",
  EXPERT_CURREnT_COMPANY_NAME = "ExpertCurrentCompanyName",
  EXPERT_NAME = "ExpertName",
  EXPERT_JOB_TITLE = "ExpertJobTitle",
  PERSONA = "Persona",
  SPEND = "Spend",
  NPS = "NPS",
  RENEWAL_INTENT = "RenewalIntent",
  IMPLEMENTATION_STAGE = "ImplementationStage",
  MODIFIED = "Modified"
}

export enum CANOPIES_LIBRARY_ORDER_BY {
  PROJECT_NAME = "ProjectName",
  CANOPY_TITLE = "CanopyTitle",
  TARGET_COMPANY_NAME = "TargetCompanyName"
}
